export default __webpack_public_path__ + "static/media/close.42ddbf22.svg";